// ==============================
// Imports
// ==============================

// Libraries
import { useState } from "react";

export default function useModal() {
  // States
  const [isOpen, setisOpen] = useState(false);

  // Handlers
  const toggle = () => {
    setisOpen(!isOpen);
  };

  return {
    isOpen,
    toggle,
  };
}
